import React from 'react';
import PropTypes from 'prop-types';
import LockView from '~/components/LockView';
import * as S from '../styles';
import Header from '~/components/Header';
import { Spinner } from '~/components';

const PrivateLayout = ({
  children,
  navBar,
  subHeader,
  location,
  isFetching,
  footer,
}) => {
  return (
    <S.Wrapper>
      {location.pathname.includes('dashboard') && <S.BGbit />}
      <S.HeaderContainer>
        <Header />
        {!isFetching && (
          <S.SubHeaderContainer id="subheader-root">
            {subHeader}
          </S.SubHeaderContainer>
        )}
      </S.HeaderContainer>
      <S.Container hasNavBar={navBar}>
        <Spinner isOpen={isFetching} disableOpacityLayer />
        <div id="modal-left-root" />
        <div id="modal-right-root" />
        <S.Content>
          <Spinner isOpen={isFetching} transparentBg />
          {!isFetching && children}
        </S.Content>
        {!(isFetching && navBar) && navBar}
      </S.Container>
      {!isFetching && <S.Footer>{footer}</S.Footer>}
      <div id="modal-root" />
      <LockView />
    </S.Wrapper>
  );
};

PrivateLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  navBar: PropTypes.node,
  subHeader: PropTypes.node,
  location: PropTypes.object,
  footer: PropTypes.node,
  isFetching: PropTypes.bool,
};

PrivateLayout.defaultProps = {
  navBar: false,
  subHeader: {},
  location: {},
  footer: null,
  isFetching: false,
};

export default PrivateLayout;
